import React from "react";
import Chart from "react-apexcharts";
import type { ApexOptions } from "apexcharts";
import { Icon } from "@iconify/react";
import { numberFormatterLabel } from "../../helper/method";

interface SalesRatioCardProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  amount: number;
  invoiceCount?: number;
  total?: number;
  percentage: number;
  color?: string;
  icon?: string;
}

export default function SalesRatioCard({
  title,
  amount,
  invoiceCount,
  percentage,
  icon,
  color,
  className,
  ...rest
}: SalesRatioCardProps) {
  const state: {
    series: ApexOptions["series"];
    options: ApexOptions;
  } = {
    series: [percentage],
    options: {
      chart: {
        height: 280,
        type: "radialBar" as const,
        width: 280,
        fontFamily: "YekanBakh-semiBold",
      },
      colors: [color],
      plotOptions: {
        radialBar: {
          hollow: {
            size: "65%",
          },
          track: {
            background: "#ededed",
            strokeWidth: "100%",
          },
          dataLabels: {
            show: false,
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        lineCap: "round",
      },
      legend: {
        fontFamily: "YekanBakh-SemiBold",
        show: false,
        position: "bottom",
        horizontalAlign: "center",
      },
    },
  };
  return (
    <div
      className={`last:border-none lg:border-l border-b border-dashed items-center flex justify-center border-grayscale-200 ${className}`}
      {...rest}
    >
      <div className="w-32 relative container-chart aspect-square">
        <Chart
          options={state.options}
          series={state.series}
          type="radialBar"
          height={"100%"}
          width={"100%"}
        />
        <div
          style={{ color: color }}
          className="absolute top-1/2 left-1/2 text-5xl text-current -translate-1/2 w-fit! h-fit! "
        >
          <Icon icon={icon ?? ""} />
        </div>
      </div>
      <div className="flex flex-col gap-3">
        <span>{title}</span>
        <span className="text-grayscale-400">{invoiceCount ?? 0} فاکتور</span>
        <span>{numberFormatterLabel(amount ?? 0)}</span>
      </div>
      <div></div>
    </div>
  );
}
